import _ from 'lodash';
import React from 'react';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import { reverse } from 'named-urls';
import routes from '@achievable-me/tundra-wizard/routes';
import { inflateContent } from '@achievable-me/tundra-wizard/contentHelpers';
import UnderlineText from '$components/library/UnderlineText';
import styles from './styles.scss';

const getChapterLines = (contentInstance) => {
  if (!contentInstance) {
    return null;
  }

  const lines = [contentInstance.title];

  let current = contentInstance.parent;

  while (current) {
    lines.unshift(current.title);
    current = current.parent;
  }

  return lines;
};

const ShareSummary = (props) => {
  const { quizState } = props;
  const { product } = quizState;
  const { content, name, shortName, slug: productSlug } = product;
  const { flatContent } = inflateContent({ product, content });

  const hasTextbookContent = _.get(
    quizState,
    'sessionHistory[0].quizObj.item.hasTextbookContent'
  );

  const isPassFail = /finra/i.test(productSlug);
  const examName = /finra-sie/i.test(productSlug) ? 'FINRA SIE' : name;

  const header = isPassFail ? (
    <UnderlineText>Pass the {examName}</UnderlineText>
  ) : (
    <UnderlineText>Reach your target score</UnderlineText>
  );

  const contentUuid = _.get(quizState, 'sessionHistory[0].quizObj.item.contentUuid');

  const contentInstance = _.find(flatContent, { uuid: contentUuid });
  const contentSlug = contentInstance ? contentInstance.slug : null;
  const chapterLines = getChapterLines(contentInstance);

  const cta = hasTextbookContent ? (
    <Link to={reverse(routes.study.learn, { productSlug, contentUuid: contentSlug })}>
      <Button data-aaa="reviewTopic" type="primary">
        Review this topic
      </Button>
    </Link>
  ) : (
    <Link to={reverse(routes.study.exams, { productSlug })}>
      <Button data-aaa="viewExams" type="primary">
        View practice exams
      </Button>
    </Link>
  );

  return (
    <div className={styles.layout}>
      {header}

      {!hasTextbookContent && (
        <div className={styles.wantMore}>Want more practice exam questions?</div>
      )}

      <div className={styles.tryAchievable}>
        You&apos;ll be well-prepared with
        <div className={styles.achievable}>{shortName}</div>
      </div>

      {hasTextbookContent && (
        <div className={styles.chapter}>
          <div className={styles.coveredIn}>This topic is covered in:</div>
          <div className={styles.chapterPrefix}>
            {product.shortName} Ch {contentInstance.titlePrefix}
          </div>
          {chapterLines.map((line, i) => (
            <div key={i}>{line}</div>
          ))}
        </div>
      )}

      {cta}
    </div>
  );
};

export default ShareSummary;
